import { put, takeLatest } from 'redux-saga/effects'
import {
  setAge,
  setDOB,
  setDriversLicense,
  setFirstName,
  setLastName,
  setMiddleInitial,
  setSSN,
} from '../store/relationshipsAndGuarantors.action'
import { RelationshipsAndGuarantorsConstants } from '../store/relationshipsAndGuarantors.constants'

export function* clearRelationshipsAndGuarantors() {
  yield put(setFirstName(''))
  yield put(setLastName(''))
  yield put(setMiddleInitial(''))
  yield put(setDriversLicense(''))
  yield put(setAge(null))
  yield put(setSSN(null))
  yield put(setDOB(null))
}

export function* clearRelationshipsAndGaurantorsSaga() {
  yield takeLatest(
    [RelationshipsAndGuarantorsConstants.CLEAR_RELATIONSHIPS_AND_GUARANTORS_DATA],
    clearRelationshipsAndGuarantors
  )
}
